import { callApi } from '@/helpers/api';
import CONFIG from '@/config/global';

const { api: { HOST, LIBRARY } } = CONFIG;

// Remove a track [by id] from the current user's library
const removeFromLibrary = (id) => {
  return callApi({
    url: HOST(LIBRARY) + LIBRARY,
    method: 'DELETE',
    body: { episode_id: id },
    errorOn404: true
  });
};

export default removeFromLibrary;